import React, { useState } from "react";
import { Collapse } from "react-collapse";
import Nav from "../Nav";
import ListItems from "../ListItems";
import dropdownIcon from '../../..//assets/icons/keyboard_arrow_down.svg'
import { IVersion } from "../../../utils/fetchers/types";

import styles from './Table.module.css'

type TTable = {
  client: string,
  versions: IVersion[];
  currentVersion: string,
}

const Table: React.FC<TTable> = ({ client, versions, currentVersion }) => {
  const [showTable, setShowTable] = useState(false);

  const handleClick = () => {
    setShowTable(!showTable);
  }

  return (
    <div className={styles.wrapper}>
      <div
        onClick={handleClick}
        className={showTable ? `${styles.labelWrapper}` : `${styles.labelWrapper} ${styles.open}`}
      >
        <div className={styles.title}>
          Download Older Versions
        </div>
        <img
          src={dropdownIcon}
          className={showTable ? `${styles.icon} ${styles.rotate}` : styles.icon}
          alt="down arrow" />
      </div>
      <Collapse isOpened={showTable}>
        <div className={styles.content}>
          <div className={styles.left}>
            <Nav
              isTableShow={showTable}
              versions={versions}
              currentVersion={currentVersion}
            />
          </div>
          <div className={styles.right}>
            <div className={styles.itemsWrapper}>
              <ListItems
                currentVersion={currentVersion}
                versions={versions}
                client={client}
              />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default Table;